window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.project_group_invitation_modal = window.locales.am.project_group_invitation_modal || {};window.locales.am.project_group_invitation_modal = {...window.locales.am.project_group_invitation_modal, ...{
    "title": "በፕሮጄክት ቡድንዎ እንኳን ደህና መጡ!",
    "description": "በዚህ ተግባር ላይ ለመተባበር ተጋብዘዋል። ከዚህ በታች ያሉትን አባላት ይገምግሙ እና ይህንን ቡድን መቀላቀል እንደሚፈልጉ ያረጋግጡ።",

                        
    "accept": "ይቀበሉ እና ቡድን ይሰተዳድሩ",
    "decline": "አይደለም፣ ይህንን ቡድን አልሰተዳድርም",

                     
    "api_error": "አንድ ነገር ተፈፃሟል። እባኮዎ እንደገና ይሞክሩዋ።",

               
    "footnote": "አንድ ስህተት ወይም የጠፋ አባላት ከተመለከቱ {email} ይላኩ።"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.project_group_invitation_modal = window.locales.ar.project_group_invitation_modal || {};window.locales.ar.project_group_invitation_modal = {...window.locales.ar.project_group_invitation_modal, ...{
    "title": "مرحباً بك في مجموعة المشروع الخاصة بك!",
    "description": "لقد تمت دعوتك للتعاون في هذه المهمة. راجع الأعضاء أدناه وأكد ما إذا كنت تريد الانضمام إلى هذا الفريق.",

                        
    "accept": "قبول وانضمام للمجموعة",
    "decline": "لا، لن أنضم إلى هذه المجموعة",

                     
    "api_error": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",

               
    "footnote": "إذا لاحظت أي أخطاء أو أعضاء مفقودين، يرجى إرسال بريد إلكتروني إلى {email}."
}
};window.locales.en = window.locales.en || {};window.locales.en.project_group_invitation_modal = window.locales.en.project_group_invitation_modal || {};window.locales.en.project_group_invitation_modal = {...window.locales.en.project_group_invitation_modal, ...{
    "title": "Welcome to Your Project Group!",
    "description": "You've been invited to collaborate on this assignment. Review the members below and confirm if you'd like to join this team.",

                        
    "accept": "Accept & Join Group",
    "decline": "No, I'm not joining this group",

                     
    "api_error": "Something went wrong. Please try again.",

               
    "footnote": "If you notice any mistakes or missing members, please email {email}."
}
};window.locales.es = window.locales.es || {};window.locales.es.project_group_invitation_modal = window.locales.es.project_group_invitation_modal || {};window.locales.es.project_group_invitation_modal = {...window.locales.es.project_group_invitation_modal, ...{
    "title": "¡Bienvenido a Tu Grupo de Proyecto!",
    "description": "Has sido invitado a colaborar en esta tarea. Revisa los miembros a continuación y confirma si te gustaría unirte a este equipo.",

                        
    "accept": "Aceptar y unirse al grupo",
    "decline": "No, no me uniré a este grupo",

                     
    "api_error": "Algo salió mal. Por favor, inténtalo de nuevo.",

               
    "footnote": "Si notas algún error o miembros faltantes, por favor envía un correo a {email}."
}
};window.locales.it = window.locales.it || {};window.locales.it.project_group_invitation_modal = window.locales.it.project_group_invitation_modal || {};window.locales.it.project_group_invitation_modal = {...window.locales.it.project_group_invitation_modal, ...{
    "title": "Benvenuto nel Tuo Gruppo di Progetto!",
    "description": "Sei stato invitato a collaborare a questo compito. Rivedi i membri qui sotto e conferma se vorresti unirti a questo team.",

                        
    "accept": "Accetta e unisciti al gruppo",
    "decline": "No, non mi unirò a questo gruppo",

                     
    "api_error": "Qualcosa è andato storto. Riprova di nuovo.",

               
    "footnote": "Se noti errori o membri mancanti, invia un'email a {email}."
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.project_group_invitation_modal = window.locales.zh.project_group_invitation_modal || {};window.locales.zh.project_group_invitation_modal = {...window.locales.zh.project_group_invitation_modal, ...{
    "title": "欢迎加入您的项目小组！",
    "description": "您已被邀请参与此作业的协作。请查看下面的成员并确认您是否愿意加入这个团队。",

                        
    "accept": "接受并加入组织",
    "decline": "不，我不加入这个组织",

                     
    "api_error": "出了点问题。请再试一次。",

               
    "footnote": "如果您发现任何错误或缺少成员，请发送电子邮件至 {email}。"
}
};